import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Table, Badge, Pagination } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { parseISO, format } from 'date-fns';
import {
  faHandHoldingBox,
  // faChevronLeft,
  // faChevronRight,
} from '@fortawesome/pro-solid-svg-icons';
import filter from 'lodash/filter';
import { apiGet } from '../../../api';
import { useStorageInventory } from '../inventory/queries';
import LoadingPlaceHolder from '../../../components/LoadingPlaceHolder';

const active = 1;
const items = [];
for (let number = 1; number <= 5; number++) {
  items.push(
    <Pagination.Item key={number} active={number === active}>
      {number}
    </Pagination.Item>
  );
}

function StoragePickLists() {
  const [pickLists, setPickLists] = useState([]);
  const { data: allInventoryItems, isFetching } = useStorageInventory();

  useEffect(() => {
    (async () => {
      const result = await apiGet(
        `storage/inventory/picklists/all?v=${Date.now()}`
      );
      const lists = await result.json();
      setPickLists(lists);
    })();
  }, []);

  return (
    <div className="portal-inner has-tabs">
      <Row>
        <Col xl={9}>
          <div className="info-box">
            <div className="info-header">
              <h3>Pick Lists</h3>
              <FontAwesomeIcon icon={faHandHoldingBox} />
            </div>
            <div className="info-content">
              <LoadingPlaceHolder isVisible={!!isFetching} />
              {!isFetching && (
                <Table responsive>
                  <thead>
                    <tr>
                      <th>List Name</th>
                      <th className="text-right">Delivery Date</th>
                      <th className="text-right">Items</th>
                      <th>Deliver To</th>
                      <th className="text-center">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!!pickLists?.length &&
                      pickLists.map((pickList) => {
                        const inventories = filter(
                          allInventoryItems,
                          (inventoryItem) =>
                            pickList.PickListID === inventoryItem.PickListID
                        );

                        return (
                          <tr>
                            <td>
                              <Link
                                to={`/portal/storage/pick-lists/${pickList.PickListID}`}
                              >
                                {pickList.PickListName}
                              </Link>
                            </td>
                            <td className="text-right">
                              {pickList.RequestedDate
                                ? format(
                                    parseISO(pickList.RequestedDate),
                                    'M/dd/yy'
                                  )
                                : ''}
                            </td>
                            <td className="text-right">{inventories.length}</td>
                            <td>{pickList.Address}</td>
                            <td className="text-center">
                              <Badge bg="warning text-body">Submitted</Badge>
                              {/* <Badge bg="success">Completed</Badge> */}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </Table>
              )}
              {/* 
              <div className="d-flex justify-content-between align-items-center mt-4">
                <Pagination>
                  <li className="page-item disabled">
                    <span className="page-link" disabled>
                      <span aria-hidden="true">
                        <FontAwesomeIcon icon={faChevronLeft} />
                      </span>
                      <span className="visually-hidden">Previous</span>
                    </span>
                  </li>
                  {items}
                  <li className="page-item">
                    <a
                      className="page-link"
                      role="button"
                      tabIndex="0"
                      href="#"
                    >
                      <span aria-hidden="true">
                        <FontAwesomeIcon icon={faChevronRight} />
                      </span>
                      <span className="visually-hidden">Next</span>
                    </a>
                  </li>
                </Pagination>
                <div className="item-count ms-4">1-22 of 22 items</div>
              </div> */}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default StoragePickLists;
